module.exports = __webpack_public_path__ + "f5379687bccdc193e4b2670b0b6041b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/first_eagle.png
// module id = 1662
// module chunks = 0